export default () =>
  import(/* webpackChunkName: 'coffee/app/agreement/sodexo' */ './Sodexo');
